import React from 'react';
import PropTypes from 'prop-types';

export class SummaryEstimation extends React.PureComponent {
  static propTypes = {
    primaryIncrease: PropTypes.string.isRequired,
    primaryPts: PropTypes.string.isRequired,
    primaryString: PropTypes.string.isRequired,
    isPositivePrimary: PropTypes.bool.isRequired,
    isDoublePrimary: PropTypes.bool,
    secondPrimaryString: PropTypes.string,
    secondPrimaryIncrease: PropTypes.string,
    secondaryIncrease: PropTypes.string,
    secondaryString: PropTypes.string,
    isPositiveSecondary: PropTypes.bool,
    spendIncrease: PropTypes.string,
    spendString: PropTypes.string,
    estimateNote: PropTypes.string.isRequired,
    primaryIncreaseSymbol: PropTypes.string,
    primaryIncreaseNullable: PropTypes.bool,
    isEstimate: PropTypes.bool,
  };

  static defaultProps = {
    secondaryIncrease: undefined,
    secondaryString: undefined,
    isPositiveSecondary: undefined,
    spendIncrease: undefined,
    spendString: undefined,
    primaryIncreaseSymbol: '+',
    primaryIncreaseNullable: undefined,
    isEstimate: true,
    isDoublePrimary: false,
    secondPrimaryString: '',
    secondPrimaryIncrease: '',
  };

  getSecondarySymbol(value) {
    let symbol = '+';
    if (Number(value) < 0 || value.includes('-')) {
      symbol = '';
    }
    return symbol;
  }

  render() {
    const {
      primaryIncreaseSymbol,
      primaryIncrease,
      primaryIncreaseNullable,
      primaryPts,
      primaryString,
      isPositivePrimary,
      secondaryIncrease,
      secondaryString,
      isPositiveSecondary,
      spendIncrease,
      spendString,
      isEstimate,
      isDoublePrimary,
      secondPrimaryString,
      secondPrimaryIncrease,
    } = this.props;
    const primaryIncreaseStr = `${primaryIncreaseSymbol}${primaryIncrease} ${primaryPts}`;
    const noPrimaryIncrease = primaryIncreaseNullable && primaryIncrease === '0';

    return (
      <div className="recommendation-estimation">
        {isEstimate && (
          <div className="estimate-note">{`${this.props.estimateNote}:`}</div>
        )}
        <div className={`estimate-primary ${isPositivePrimary ? 'positive-estimate' : 'neutral-estimate'}`}>
          {noPrimaryIncrease ?
            <span className="iconba large iconba-Trending12" />
            : <span className="estimate-primary-value">{primaryIncreaseStr}</span>}
          <span className="estimate-primary-title">{primaryString}</span>
        </div>
        {(isDoublePrimary) && (
          <div className="second-primary neutral-estimate">
            <span className="estimate-second-value">{`${secondPrimaryIncrease} `}</span>
            <span className="estimate-second-title">{secondPrimaryString}</span>
          </div>
        )}
        {secondaryIncrease && (
          <div className={`estimate-secondary ${isPositiveSecondary ? 'positive-estimate' : 'neutral-estimate'}`}>
            <span className="estimate-secondary-value">{this.getSecondarySymbol(secondaryIncrease)}{secondaryIncrease}</span>
            <span>&nbsp;</span>
            <span className="estimate-secondary-title">{secondaryString}</span>
          </div>
        )}
        {spendIncrease && (
          <div className="estimate-cost">
            <span className="estimate-cost-value">+{spendIncrease}</span>
            <span>&nbsp;</span>
            <span className="estimate-cost-title">{spendString}</span>
          </div>
        )}
      </div>
    );
  }
}

